import styled, { keyframes } from 'styled-components';

const placeHolderShimmer = keyframes`
  0% { background-position: -500px 0 }
  100% {  background-position: 500px 0 }
`;

export const Tag = styled.div`
  position: relative;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  will-change: background-position;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: linear;
  width: ${props => (props.width)};
  height: ${props => (props.height)};
  background: linear-gradient(90deg,hsl(0deg 0% 29%) 8%,hsl(0deg 0% 25%) 18%,hsl(0deg 0% 29%) 33%);
  background-size: 1200px 104px;
`;
